<template>
  <span class="inline">
    <span v-if="msg" v-on:mouseover="hover" v-on:mouseout="hoverOut" class="excel-column-info">{{ msg }}</span>
    <span v-else v-on:mouseover="hover" v-on:mouseout="hoverOut" class="excel-column-info">
      <img v-if="!showPopup" src="/static/images/icons/info_icon_reg_details.svg" class="hide_xs" />
      <img v-else src="/static/images/icons/emergo_info_hover.svg" class="hide_xs" alt="" />
    </span>
    <div
      class="excel-popover"
      v-if="showPopup"
      transition="fade"
      v-on:mouseover="hoverInfo"
      v-on:mouseout="hoverOutInfo"
      :style="largeBlock"
    >
      <div class="popover-text" v-if="msg">
        <div>
          Because you have uploaded your own spreadsheet, Conformity Declaration Management cannot be sure which column in your spreadsheet
          contain certain registration data.
        </div>
        <br />
        <div>
          By identifying which columns in your spreadsheet contain certain data, you'll help Conformity Declaration Management import your
          registrations correctly.
        </div>
        <br />
        <div>
          To skip this step, you can enter your registrations into our spreadsheet template
          <a href="/static/template/RegistrationExcelTemplate.xlsx">(download here)</a> and then upload the filled out
          template.
        </div>
      </div>
      <div class="popover-text" v-else-if="from === 'team'">
        <p class="role-def">{{$t('roleDefinition')}}</p>
        <p class="role-admin" v-if="roleId == 1">{{$t('accountOwner')}}: {{$t('accountOwnerPara1')}} {{$t('accountOwnerPara2')}}.</p>
        <p class="role-user" v-if="roleId == 2 || roleId == 1 ">Editor: {{$t('editPara')}}.</p>
        <p class="role-admin" v-if="roleId === roleInfo['RA Admin']">{{$t('RAAdmin')}}: {{$t('RAAdminPermissions')}} {{$t('viewerPara2')}}.</p>
        <p class="role-admin" v-if="roleId === roleInfo['RA Viewer']">{{$t('RAviewer')}}: {{$t('RAviewerPermissions')}} {{$t('viewerPara2')}}.</p>
        <p class="role-admin" v-if="roleId === roleInfo['Super Admin']">{{$t('superAdmin')}}: {{$t('superAdminPermissions')}}</p>
        <p class="role-user" v-if="roleId === 3 || roleId == 1">{{$t('viewer')}}: {{$t('viewerPara1')}} {{$t('viewerPara2')}}.</p>
      </div>
      <div class="popover-text" v-else>
        <div class="popover-field-name">{{ info.split(';')[0] }}</div>
        <div class="info-tooltip-hr"><hr /></div>
        <div>{{ info.split(';')[1] }}</div>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  props: ['info', 'msg', 'from', 'roleId', 'roleInfo'],
  data() {
    return {
      showPopup: false,
      timer: '',
      isInInfo: false
    };
  },
  computed: {
    largeBlock() {
      if (this.msg) {
        return {
          width: '550px',
          left: '0%'
        };
      }
      return {};
    }
  },
  methods: {
    hover() {
      const vm = this;
      this.timer = setTimeout(() => {
        vm.showPopover();
      }, 400);
    },

    hoverOut() {
      const vm = this;
      clearTimeout(vm.timer);
      this.timer = setTimeout(() => {
        if (!vm.isInInfo) {
          vm.closePopover();
        }
      }, 200);
    },

    hoverInfo() {
      this.isInInfo = true;
    },

    hoverOutInfo() {
      this.isInInfo = false;
      this.hoverOut();
    },

    showPopover() {
      this.showPopup = true;
    },

    closePopover() {
      this.showPopup = false;
    }
  }
};
</script>
<style scoped>
.role-def {
  font-weight: 600 !important;
  padding-top: 7px;
}
.role-def, .role-admin, .role-user {
  font-size: 16px;
  color: #4D4D4D;
  font-weight: 400;
}
.role-user {
  padding-top: 6px;
}
.popover-field-name {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #01518a;
  padding-top: 7px;
}
.excel-column-info {
  padding-right: 0px !important;
}

.excel-popover {
  z-index: 90;
}
.excel-popover:after {
  position: absolute;
  top: -13px;
  left: 9px;
  height: 0;
  width: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 17px solid #fff;
  content: '';
}
.info-tooltip-hr {
  padding: 4px 10px 8px 0px;
}
.info-tooltip-hr hr {
  margin: 0px;
  border-top: 0.25px solid #828282;
}

.excel-popover {
  left: -18% !important;
  top: 53px !important;
  background: #000001;
  color: #ffffff;
}

.popover-text {
  background: #000001;
  color: #ffffff;
  border-radius: 5px;
}

.popover-field-name {
  color: #ffffff;
}

.excel-popover:after {
  left: 42%;
  top: -9px;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-bottom: 10px solid #000001;
}
</style>
